// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero-line-module--wrapper--2kNSg","line":"hero-line-module--line--1g2-U","arrows":"hero-line-module--arrows--1iMjP","arrowsImage":"hero-line-module--arrowsImage--238Ri"};